import { v4 as uuid } from "uuid";

export const sliderItems = [
  {
    bg: "000316",
    id:uuid(),
    img: "https://images.unsplash.com/photo-1607250267267-29ac1fdc4536?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    title: "MOON LAMPS",
    desc: "POPULAR ! GET FLAT 30% OFF FOR SPACE LOVERS.",
  },
  {
    bg:"a9781f",
    id:uuid(),
    img: "https://images.unsplash.com/photo-1519913974306-4c20d7349ee5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    title: "LAMPS LOVE",
    desc: "DON'T COMPROMISE ON LIGHTS! GET FLAT 30% OFF FOR NEW ARRIVALS.",
   
  },
  {
    bg:"04b8e5",
   id:uuid(),
    img: "https://images.unsplash.com/photo-1551029506-0807df4e2031?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1334&q=80",
    title: "BOOKS SALE",
    desc: "DON'T COMPROMISE ON BOOKS! GET FLAT 30% OFF FOR NEW ARRIVALS.",
   
  },
];

export const serviceItems =[
  {
     id:uuid(),
    title:"24/7 Support",
    icon:"fa fa-commenting bold-grey-text",
    info:"In safe Hands"
  },
  {
     id:uuid(),
    title:"Free Shipping",
    icon:"fa fa-truck bold-grey-text",
    info:"Deliver To Door"
  },
  {
     id:uuid(),
    title:"Easy Payment",
    icon:"fa fa-credit-card bold-grey-text",
    info:"Shop with us"
  },
  {
     id:uuid(),
    title:"Big Discounts",
    icon:"fa fa-percent bold-grey-text",
    info:"On Big Stock"
  }
];

export const featureItem =[
  {
     id:uuid(),
    title:"Gift",
    product:"Telescope",
    img:"https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcTmPgjWD-wk7fkTAFpsl9-l8xTfRZrprdUIG1DOsD5o0aNQ-T5LJEw5rN-UqIJMhsiZ17OgH6ycs7WVkuswUxvYLU788nvz2rvWblHerilc&usqp=CAc",
    price:"$79"
  },
  {
     id:uuid(),
    title:"Glasses",
    product:"Galaxy Mug",
    img:"https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSkXUu-WONPERS9mMNlq0SyWAdZXuhXQjXlqkTBUxBja8WjuF8l83BCFa9l04GBi8LwitjVN8f1rJXIZWMql5IvUHTSoumZf0BUHfjC-nXE&usqp=CAc",
    price:"$9"
  },
  {
     id:uuid(),
    title:"toys",
    product:"Space crafts",
    img:"https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcS-NsNO_ZpGCnpkwnqu4164qw_KWNWV8hd82ZIpbjn1SCpcJjYPL7TxA8T8WE-MbN_y9o5Cqq73ssNWBK8BEeup78oqwkUgX_XqfeTQwxc&usqp=CAc",
    price:"$5"
  },
  {
     id:uuid(),
    title:"Lights",
    product:"Lamp humidifier",
    img:"https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcRLA_8c6vSVzfVCkPHQiYAoN0p5Ox9riqDLYk3GNnnehBNLPIh2MzAVb7cnc4pIKK6VKUZjDwE9fCONxV6ktpohRE4l2-ADjCKrJox5xbNWGfI6GW3IWCff1g&usqp=CAc",
    price:"$10"
  }
];

export const SecfeatItem =[
  {
     id:uuid(),
    title:"Clothes",
    product:"T-shirt",
    img:"https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcQH32gIWNDTVK9Bd5xpRdNxf_7ZXOYoue_DxAyeeuX0r_dXU3xAAbbeVn2tV_0WgACrvY6S0bQgi5t8cr36O-PwuoccF0LCFjp6Yvw_bVAVC7X2-RRRlFT62w&usqp=CAE",
    price:"$79"
  },
  {
     id:uuid(),
    title:"Accessories",
    product:"Astronomy Bracelet",
    img:"https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcQrA_3rzWwK0KPNpVeHmaf2B768ocyTBHBJ3gBj1xq1XEMpfZWjgxhY7zOMNt6bakhXpKPVbCmoX0R2D8wHpO_YRUXuIgtiW_l-SLgCFFBe&usqp=CAE",
    price:"$29"
  },
  {
     id:uuid(),
    title:"toys",
    product:"Astronaut",
    img:"https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcRAuJe_UA5-WRMHgjppPs2f5yxEsm3HRsQlmGK_0UskVY0wWC_U0qxAX4p9ka3_3x93G1J5zT2SUE-0GCteZ6NxPgVTaMjZZZpyviwzIJI&usqp=CAE",
    price:"$15"
  },
  {
     id:uuid(),
    title:"Glasses",
    product:"Mug",
    img:"https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcSgc6kACBqKAubVE41bWqd-_FsAyBILECClL08riOwtfH3f6sECbslEtdRKdGGJXg-LqYcXrUtxh6lGWBRzHj48gABARStALkYMA7K_eoKaEL86nW431A00&usqp=CAE",
    price:"$30"
  }
];

export const popularItem =[
  {
   
    img:'https://www.transparentpng.com/thumb/book/YJK1qb-books-free-cut-out.png',
    title:"Books",
    listOne:"Astronomy Books",
    listTwo:"Encyclopedia",
    listThree:"Space history",
    listFour:"Science fiction",
   id:uuid()
  },
  {
   
    img:'https://www.transparentpng.com/thumb/digital-camera/lvQtcL-digital-camera-high-quality.png',
    title:"Digital",
    listOne:"Cameras",
    listTwo:"Smart Appliances",
    listThree:"Blenders",
    listFour:"Lights",
   id:uuid()
  },
  {
    img:'https://www.transparentpng.com/thumb/kids/EMkjl5-kids-brother-png-icon.png',
    title:"Toys",
    listOne:"Soft toys",
    listTwo:"Miniature gifts",
    listThree:"Puzzles",
    listFour:"Action figures",
   id:uuid()
  },
]

export const ImgLayoutItems =[
  {
   id:uuid(),
    class:"item item1",
    name:"celestron",
    price:"From $190.00",
  },
  {
   id:uuid(),
    class:"item item2",
    name:"meade",
    price:"From $90.00",
  },
  {
   id:uuid(),
    class:"item item3",
    name:"generic",
    price:"From $10.00",
  },
  
]

export const review=[
  {
    date:"06 Dec 2021",
    name:"Vashnavi",
    icon:"5star",
    message:"Now,if you are interested in space this is the correct place to explore",
   id:uuid()
  },
  {
    date:"06 Dec 2021",
    name:"Adrian Malana",
    icon:"4star",
    message:"Now,if you are interested in space this is the correct place to explore",
   id:uuid()
  },
  {
    date:"06 Dec 2021",
    name:"Alex joy",
    icon:"3star",
    message:"Now,if you are interested in space this is the correct place to explore",
   id:uuid()
  }
];